import {TemplateRef} from '@angular/core';
import {I18nMessage} from '@shared/api/model/i18n';

export enum ToastType {
  Success = 'success', Info = 'info', Warning = 'warning', Danger = 'danger', Primary = 'primary', Secondary = 'secondary', Light = 'light', Dark = 'dark'
}

export interface Toast<T = any> {
  type: ToastType;
  timeout?: number;
  dismissible?: boolean;
  template?: TemplateRef<any>;
  error?: boolean;
  text?: string;
  message?: I18nMessage;
  /** Used to close toast. Can also be used to show same toast only once by passing same id for same toasts */
  toastId?: string;
  data?: T;
}
